```vue
<template>
  <div style="padding: 20px;">
    <!-- 下载按钮 -->
    <div style="display: flex">

      <el-input v-model="khtoken" style="width: 300px;margin-right: 20px;"
                placeholder="请输入token" />
      <el-button type="primary" @click="exportExcel">下载Excel模板</el-button>

      <!-- 导入按钮 -->
      <el-upload
        style="margin-left: 20px;"
        :show-file-list="false"
        accept=".xlsx, .xls"
        :before-upload="importExcel"
      >
        <el-button type="success">导入Excel</el-button>
      </el-upload>

      <!-- 执行按钮 -->
      <el-button type="danger" style="margin-left: 20px;" @click="executeRequests" :loading="loading">
        执行
      </el-button>
    </div>

    <!-- 数据展示表格 -->
    <el-table v-if="tableData.length" :data="tableData" border style="margin-top: 20px; width: 100%;">
      <el-table-column prop="productName" label="产品名" />
      <el-table-column prop="accountName" label="广告账户名" />
      <el-table-column prop="accountId" label="广告uuid" />
      <el-table-column prop="sourceId" label="数据源id" />
      <el-table-column prop="action" label="广告转化目标" />
      <el-table-column prop="title" label="吊起剧名" />
      <el-table-column prop="token" label="账户token" />
      <el-table-column prop="behavior" label="回传行为" />
      <el-table-column prop="specialCase" label="特殊情况" />
    </el-table>
  </div>
</template>

<script>
import * as XLSX from "xlsx";
import axios from "axios";

export default {
  name: "ExcelImportExport",
  data() {
    return {
      khtoken: '',
      tableData: [],
      loading: false,
      appKeyMap: {
        "趣多拍": "quduopaikyy",
        "趣星": "quxingjuyuan",
        "魔豆": "midukyy",
        "米读极速版": "midufastkyy",
        "闪购趣仓": "dsddja",
      },
      specialCaseOptions: ["无特殊情况", "清理类素材", "天气类素材"], // 下拉选项
    };
  },
  methods: {
    /** 导出Excel模板 */
    exportExcel() {
      const header = [
        "产品名",
        "广告账户名",
        "广告uuid",
        "数据源id",
        "广告转化目标",
        "吊起剧名",
        "账户token",
        "回传行为",
        "特殊情况", // 新增字段
      ];
      const ws = XLSX.utils.aoa_to_sheet([header]);

      // 给特殊情况加下拉选择（B2:J100 只是示例，你可以扩展范围）
      ws["!dataValidations"] = [
        {
          type: "list",
          allowBlank: true,
          sqref: "I2:I1000", // I列为“特殊情况”，2行到1000行
          formulas: [`"${this.specialCaseOptions.join(",")}"`],
        },
      ];

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "模板");
      XLSX.writeFile(wb, "导入模板.xlsx");
    },

    /** 导入Excel */
    importExcel(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const json = XLSX.utils.sheet_to_json(worksheet);
        // 映射到tableData
        this.tableData = json.map((item) => ({
          productName: item["产品名"],
          accountName: item["广告账户名"],
          accountId: item["广告uuid"],
          sourceId: item["数据源id"],
          action: item["广告转化目标"],
          title: item["吊起剧名"],
          token: item["账户token"],
          behavior: item["回传行为"],
          specialCase: item["特殊情况"] || "无特殊情况", // 默认无特殊情况
        }));
      };
      reader.readAsArrayBuffer(file);
      return false; // 阻止默认上传
    },

    /** 执行逻辑 */
    async executeRequests() {
      if (!this.tableData.length) {
        this.$message.warning("请先导入数据");
        return;
      }
      this.loading = true;
      for (let row of this.tableData) {
        try {
          const appKey = this.appKeyMap[row.productName];
          if (!appKey) {
            this.$message.error(`未找到产品名对应的appKey: ${row.productName}`);
            continue;
          }

          let payload = {
            deliveryName: "vivo",
            accountId: row.accountId,
            accountName: row.accountName,
            sourceId: row.sourceId,
            secret: row.token,
            action: row.behavior,
            token: this.khtoken,
            appKey: appKey,
          };

          if (row.specialCase === "无特殊情况") {
            // 原逻辑
            const getRes = await axios.get("https://yqs-api.aiclk.com/ping/account/getSeriesList", {
              params: {
                token: this.khtoken,
                appKey,
                title: row.title,
              },
            });

            if (getRes.data.code !== 200 || !getRes.data.data.length) {
              this.$message.error(`获取剧集失败: ${row.title}`);
              continue;
            }

            const seriesData = getRes.data.data[0];
            const seriesStr = `${seriesData.id} - ${seriesData.title}`;

            payload = {
              ...payload,
              hapType: "0",
              series: seriesStr,
              seriesId: String(seriesData.id),
            };

          } else if (row.specialCase === "清理类素材") {
            payload = {
              ...payload,
              hapType: "1",
            };

          } else if (row.specialCase === "天气类素材") {
            payload = {
              ...payload,
              hapType: "3",
            };
          }

          await axios.post("https://yqs-api.aiclk.com/ping/account/create", payload, {
            headers: {
              Host: "yqs-api.aiclk.com",
              "User-Agent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64; rv:142.0) Gecko/20100101 Firefox/142.0",
              Accept: "application/json, text/plain, */*",
              "Accept-Language": "zh-CN,zh;q=0.8",
              "Content-Type": "application/json",
              Origin: "https://yqs.aiclk.com",
              Referer: "https://yqs.aiclk.com/",
              Connection: "keep-alive",
            },
          });

          this.$message.success(`执行成功: ${row.accountName} - ${row.title}`);
        } catch (error) {
          console.error(error);
          this.$message.error(`执行失败: ${row.accountName} - ${row.title}`);
        }
      }
      this.loading = false;
    },
  },
};
</script>
```



// WEBPACK FOOTER //
// src/components/kehu/batchqdx.vue